import './App.css';
import './components/formStyleSheet/FormStyling.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import Router from './routes/Routes';
import { useEffect } from 'react';
import { placeholderimg } from './assets/imagesPath';

const App = () => {

  useEffect(() => {
    const handleImageError = (e) => {
      if (e.target.tagName === 'IMG') {
        e.target.src = placeholderimg;
        e.target.onerror = null;
      }
    };

    document.addEventListener('error', handleImageError, true);

    return () => {
      document.removeEventListener('error', handleImageError, true);
    };
  }, []);

  useEffect(() => {
    const handleGlobalNumberInput = (event) => {
      if (event.target.type === "number") {
        const value = event.target.value;
        if (value <= 0) {
          event.target.value = "";
        }
      }
    };

    const preventScrollOnWheel = (event) => {
      if (event.target.type === "number") {
        event.preventDefault();
      }
    };

    document.addEventListener("input", handleGlobalNumberInput);
    document.addEventListener("wheel", preventScrollOnWheel, { passive: false });

    return () => {
      document.removeEventListener("input", handleGlobalNumberInput);
      document.removeEventListener("wheel", preventScrollOnWheel);
    };
  }, []);

  return (
    <Router />
  );
};

export default App;